export const AuditEventType = {
  SHIPMENT_DIALOG_OPENED: 'SHIPMENT_DIALOG_OPENED',
  LABEL_RETRIEVAL_STARTED: 'LABEL_RETRIEVAL_STARTED',
  LABEL_RETRIEVAL_COMPLETED: 'LABEL_RETRIEVAL_COMPLETED',
  LABEL_RETRIEVAL_FAILED: 'LABEL_RETRIEVAL_FAILED',
  PRINT_REQUESTED: 'PRINT_REQUESTED',
  PRINTER_DISCOVERY_STARTED: 'PRINTER_DISCOVERY_STARTED',
  PRINTER_IDENTIFIED: 'PRINTER_IDENTIFIED',
  PRINTER_NOT_FOUND: 'PRINTER_NOT_FOUND',
  PRINT_JOB_SUBMITTED: 'PRINT_JOB_SUBMITTED',
  PRINT_JOB_FAILED: 'PRINT_JOB_FAILED',
  PRINT_JOB_COMPLETED: 'PRINT_JOB_COMPLETED',
  SHIPMENT_LABEL_DOWNLOADED: 'SHIPMENT_LABEL_DOWNLOADED',
};

export const AuditEventCode = {
  // UI Events
  SHIPMENT_DIALOG_OPENED: 10021,
  LABEL_RETRIEVAL_STARTED: 10022,
  LABEL_RETRIEVAL_COMPLETED: 10023,
  LABEL_RETRIEVAL_FAILED: 10024,
  PRINT_REQUESTED: 10025,
  PRINTER_DISCOVERY_STARTED: 10026,
  PRINTER_IDENTIFIED: 10027,
  PRINTER_NOT_FOUND: 10028,
  PRINT_JOB_SUBMITTED: 10029,
  PRINT_JOB_COMPLETED: 10030,
  PRINT_JOB_FAILED: 10031,
  SHIPMENT_LABEL_DOWNLOADED: 10033,
};

export const AuditEventDescription = {
  SHIPMENT_DIALOG_OPENED: 'Shipment dialog opened',
  LABEL_RETRIEVAL_STARTED: 'Label retrieval from S3 started',
  LABEL_RETRIEVAL_COMPLETED: 'Label retrieval from S3 completed',
  LABEL_RETRIEVAL_FAILED: 'Label retrieval from S3 failed',
  PRINT_REQUESTED: 'Print requested',
  PRINTER_DISCOVERY_STARTED: 'Printer discovery started',
  PRINTER_IDENTIFIED: 'Printer identified',
  PRINTER_NOT_FOUND: 'Printer not found',
  PRINT_JOB_SUBMITTED: 'Print job submitted to printer',
  PRINT_JOB_FAILED: 'Print job failed',
  PRINT_JOB_COMPLETED: 'Print job completed',
  SHIPMENT_LABEL_DOWNLOADED: 'Shipment label downloaded',
};

export const AuditActorRole = {
  POM_USER: 'POM_USER',
};

export const AuditEventStatus = {
  STARTED: 'STARTED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};
